import React from 'react';

/* ─── Lazy-load with automatic retry on stale-chunk errors (RW-859) ───
 * Extracted from App.js so any lazy boundary (App routes, AdminDashboard
 * sections, …) shares the same recovery behavior. When a fingerprinted chunk
 * has been pruned by a newer deploy the dynamic import rejects; reload once so
 * the fresh index.html points at live chunks. The sessionStorage guard caps
 * auto-reloads at one per 10 seconds to prevent an infinite reload loop. */
export default function lazyWithRetry(importFn) {
  return React.lazy(() =>
    importFn().catch((error) => {
      // Prevent infinite reload loop — only auto-reload once per 10 seconds
      const lastReload = parseInt(sessionStorage.getItem('chunk-reload') || '0', 10);
      if (Date.now() - lastReload < 10000) {
        throw error; // let ErrorBoundary show "Page failed to load"
      }
      sessionStorage.setItem('chunk-reload', Date.now().toString());
      window.location.reload();
      return new Promise(() => {}); // never resolves — page reloads
    })
  );
}
